import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { StopOutlined } from "@ant-design/icons";

export default function FeatureUnavailable() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Result
        icon={<StopOutlined style={{ color: "#ff4d4f" }} />}
        title="Раздел временно недоступен"
        subTitle="Этот раздел был отключен администратором. Обратитесь к администратору для получения доступа."
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            Перейти на главную
          </Button>
        }
      />
    </div>
  );
}
